import { useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { useTranslation } from 'react-i18next'
import { formatISODate } from 'utils/dates'
import { UIButton } from 'components/ui/Button'
import { useModalActions } from 'providers/ModalProvider'

export const TicketInfoCard = () => {
  const { t } = useTranslation()
  const { showCloseTicket } = useModalActions()
  const isInOperatorMode = useSelector(messagesSelectors.currentChatIsInOperatorMode)
  const ticket = useSelector(messagesSelectors.currentChatTicket)
  const disableFieldsTicketClosed = useSelector(messagesSelectors.disableFieldsTicketClosed)

  if (!isInOperatorMode || !ticket) {
    return null
  }

  return (
    <div
      className="tw-w-full tw-rounded-xl tw-px-3 tw-py-3 tw-text-sm"
      style={{
        backgroundColor: 'var(--bot-msg-bg)',
        color: 'var(--bot-msg-text)',
        border: '1px solid var(--border-default)',
      }}
    >
      <div className="tw-flex tw-flex-col tw-gap-1">
        <div className="tw-font-bold">{t('youOpenedATicket')}</div>
        <div className="tw-text-sm">
          <span className="tw-font-semibold">{t('title')}: </span>
          <span>{ticket.title}</span>
        </div>
        <div className="tw-text-sm tw-line-clamp-2">
          <span className="tw-font-semibold">{t('description')}: </span>
          <span>{ticket.description}</span>
        </div>
        <div className="tw-text-xs tw-opacity-90 tw-capitalize tw-italic" style={{ color: 'var(--text-muted)' }}>
          {formatISODate(ticket.createdAt)}
        </div>
        <UIButton
          disabled={disableFieldsTicketClosed}
          onClick={() => showCloseTicket({ ticketId: ticket._id })}
          className="tw-mt-1 tw-w-full"
        >
          <span className="tw-text-sm">{disableFieldsTicketClosed ? t('closedTicket') : t('closeTicket')}</span>
        </UIButton>
      </div>
    </div>
  )
}
